import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const SavingsPlanMain = WithErrorBoundary(
  'Plan de ahorro',
  'Error en plan de ahorro',
  React.lazy(() => import('./SavingsPlanMain')),
)

const SavingsPlanSubscription = WithErrorBoundary(
  'Plan de ahorro',
  'Error en suscripcion de plan de ahorro',
  React.lazy(() => import('../savings-plan-subscription/MainSavingsPlan.container')),
)

export default {
  path: '/presupuestador/plan-de-ahorro',
  name: 'Plan de ahorro',
  childRoutes: [
    { path: '', name: 'Savings Plan main', component: SavingsPlanMain, isIndex: true },
    { path: 'crear', name: 'Main subscription', component: SavingsPlanSubscription },
    { path: 'editar/:id', name: 'Main subscription', component: SavingsPlanSubscription },
    { path: 'ver/:id', name: 'Main subscription', component: SavingsPlanSubscription },
  ],
}
